import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    sendDummy: {
      error:
        'An error occurred while sending the test email. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
      success: 'Test email sent!',
    },
    title: {
      inProgress: 'Quote in progress',
      withFiscalId: 'Quote n°{0}',
    },
  },
  fr: {
    sendDummy: {
      error:
        'Une erreur est survenue lors de l’envoi de l’e-mail de test. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
      success: 'E-mail de test envoyé\xA0!',
    },
    title: {
      inProgress: 'Devis en cours',
      withFiscalId: 'Devis n°{0}',
    },
  },
} as const);

export default locales;
